<template>
    <v-card class="card-container">
        <v-card-title>
            <v-row no-gutters>
                <v-col>
                    <v-text-field
                            class="search-block"
                            v-model="search"
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo
                            placeholder="Поиск"
                            dense
                            hide-details
                    />
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <span style="font-weight: 500;font-size: 16px;line-height: 20px;">Всего активаций:</span> <span style="font-weight: 600;font-size: 24px;line-height: 40px;">{{filteredItems.length}}</span>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <v-data-table
                    :loading="loading"
                    no-data-text="Нет элементов"
                    no-results-text="Не найдено элементов"
                    loading-text="Загрузка данных"
                    calculate-widths
                    :items-per-page="filteredItems.length"
                    :items="filteredItems"
                    :headers="fields"
                    :search="search"
                    height="100%"
                    hide-default-footer
                    class="elevation-1 h-100 px-2"
            >
                <template v-slot:item.bonusPacket="{item}">
                    <div :class="{'bonus-container':true,'bonus-1':item.bonusPacketCode=='BP01','bonus-2':item.bonusPacketCode=='BP02', 'bonus-3':item.bonusPacketCode=='BP03','bonus-0':item.bonusPacketCode=='BP00'}"><div>{{item.bonusPacket}}</div></div>
                </template>
                <template v-slot:item.applyDate="{item}">
                    <span>{{formatDateMounthName(item.applyDate)}}</span>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "PartnerInfoActivates",
        props:{
            item:Object,
        },
        data(){
            return {
                search:null,
                loading:null,
                fields:[
                    {text: 'Бонус', value: 'bonus'},
                    {text: 'ФИО клиента', value: 'client'},
                    {text: 'Машина', value: 'clientCar'},
                    {text: 'Пакет', value: 'bonusPacket'},
                    {text: 'Адрес', value: 'orgGeoInfo'},
                    {text: 'Списал', value: 'webUser'},
                    {text: 'Дата списания', value: 'applyDate'},
                ]
            }
        },
        mounted(){
            this.$store.dispatch("Partners/getActivations", this.item.id).catch(err=>{
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка активаций!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })
        },
        computed:{
            filteredItems(){
                return this.$store.state.Partners.partnerActivations
            },

        },
    }
</script>

<style scoped>

</style>